import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DollarCircleFilledSvg from "@ant-design/icons-svg/es/asn/DollarCircleFilled";
import AntdIcon from "../components/AntdIcon";
var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DollarCircleFilled.displayName = 'DollarCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(DollarCircleFilled);